/**
 * POS Pincode Dialog
 */

import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, useTheme } from '@mui/material'
import { PinInput } from 'react-input-pin-code'
/** ICONS */
import VpnKeyIcon from '@mui/icons-material/VpnKey'

interface PincodeDialogProps {
	open: boolean
	onClose: () => void
	onSubmit: (pincode: string) => void
}

const PincodeDialog = (props: PincodeDialogProps) => {
	const [pincode, setPincode] = React.useState(['', '', '', ''])
	const [open, setOpen] = React.useState(false)

	const theme = useTheme()

	React.useEffect(() => {
		if (props.open) {
			setOpen(true)
		} else {
			setOpen(false)
			setPincode(['', '', '', ''])
		}
	}, [props.open])

	const handleClose = () => {
		setOpen(false)
		setTimeout(() => {
			props.onClose()
		}, 350)
	}

	const handleSubmit = () => {
		props.onSubmit(pincode.join(''))
	}

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
			<form onSubmit={(e) => {
				e.preventDefault();
				handleSubmit();
			}}>
			<DialogTitle>
				<VpnKeyIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
				Пинкодоо оруулна уу
			</DialogTitle>
			<DialogContent>
				<Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2,
                }}>
					<PinInput values={pincode} onChange={(value, index, values) => setPincode(values)} autoFocus
						inputStyle={{
							color: theme.palette.mode === 'dark' ? 'white' : 'black'
						}}
						validBorderColor='none'
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Болих</Button>
				<Button variant="contained" type="submit" disabled={pincode.includes('')}>
					Үргэлжлүүлэх
				</Button>
			</DialogActions>
			</form>
		</Dialog>
	)
}

export default PincodeDialog
